var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-none d-md-flex justify-content-between align-items-baseline"},[_c('h3',{staticClass:"hb3 mb-3"},[_vm._v(_vm._s(this.$store.state.navigation.sectionHeader))])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }